/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePresentationRequest } from '../models/CreatePresentationRequest';
import type { PageBriefPresentatiionDto } from '../models/PageBriefPresentatiionDto';
import type { PresentationDto } from '../models/PresentationDto';
import type { SlideDataResponse } from '../models/SlideDataResponse';
import type { UpdatePresentationRequest } from '../models/UpdatePresentationRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PresentationProcessingApiService {
  /**
   * Get pageable presentations
   * Returns a presentations
   * @param xAiAgentOrganizationContext
   * @param search
   * @param page
   * @param size
   * @param sort
   * @returns PageBriefPresentatiionDto Presentation found
   * @throws ApiError
   */
  public static getPresentations(
    xAiAgentOrganizationContext: string,
    search?: string,
    page?: number,
    size?: number,
    sort?: Array<string>
  ): CancelablePromise<PageBriefPresentatiionDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/presentations',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      query: {
        search: search,
        page: page,
        size: size,
        sort: sort,
      },
    });
  }
  /**
   * Creates presentation from presentation file
   * Accepts presentation files and returns structured slide data.
   * @param xAiAgentOrganizationContext
   * @param formData
   * @returns SlideDataResponse List of DTOs representing structured slides data.
   * @throws ApiError
   */
  public static processPresentation(
    xAiAgentOrganizationContext: string,
    formData: FormData
  ): CancelablePromise<Array<SlideDataResponse>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/presentations',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      body: formData,
      mediaType: 'multipart/form-data',
      errors: {
        500: `Internal server error`,
      },
    });
  }
  /**
   * Get presentation by id
   * Returns a presentation with generated slide image URLs
   * @param xAiAgentOrganizationContext
   * @param presentationId
   * @returns PresentationDto Presentation found
   * @throws ApiError
   */
  public static getPresentation(
    xAiAgentOrganizationContext: string,
    presentationId: string
  ): CancelablePromise<PresentationDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/presentations/{presentationId}',
      path: {
        presentationId: presentationId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        404: `Presentation not found`,
      },
    });
  }
  /**
   * Delete presentation by id
   * Deletes a presentation and its related resources
   * @param xAiAgentOrganizationContext
   * @param presentationId
   * @returns void
   * @throws ApiError
   */
  public static deletePresentation(
    xAiAgentOrganizationContext: string,
    presentationId: string
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/presentations/{presentationId}',
      path: {
        presentationId: presentationId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        404: `Presentation not found`,
      },
    });
  }
  /**
   * Update presentation metadata
   * Updates only title and description of a presentation without touching slides
   * @param xAiAgentOrganizationContext
   * @param presentationId
   * @param requestBody
   * @returns PresentationDto Presentation updated
   * @throws ApiError
   */
  public static updatePresentation(
    xAiAgentOrganizationContext: string,
    presentationId: string,
    requestBody: UpdatePresentationRequest
  ): CancelablePromise<PresentationDto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/presentations/{presentationId}',
      path: {
        presentationId: presentationId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Presentation not found`,
      },
    });
  }
}
